import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fill-height":"","fluid":"","grid-list-xl":""}},[_c(VLayout,{attrs:{"justify-center":"","wrap":""}},[_c(VFlex,{attrs:{"md12":""}},[_c('div',[_c('material-card',[_c(VForm,{staticClass:"text-center",on:{"submit":function($event){$event.preventDefault();return _vm.download.apply(null, arguments)}}},[_c(VBtn,{attrs:{"disabled":_vm.downloading,"color":"blue light","type":"submit"}},[_vm._v(_vm._s(_vm.$t("language.backupdownload")))])],1)],1)],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }